<template>
    <div class="metadata-container">
        <div class="user-info">
            <span class="profile"><img v-if="profilePicture" :src="profilePicture" alt="Avatar de usuario" /></span>
            <h3>
                {{ userName }}
                <span>{{ email }}</span>
            </h3>
        </div>
        <span v-if="!hasSidebarMenu"></span>
        <div v-if="hasSidebarMenu" class="sidebar-menu">
            <ion-icon v-if="!isSidebarMenuOpen" name="menu-outline" @click="toggleMenu"></ion-icon>
            <ion-icon v-else name="close-outline" @click="toggleMenu"></ion-icon>
        </div>
        <h1 @click="goHome"><img class="logo" src="@/assets/isologotipo_chatpts_transparente.svg" /></h1>
        <div class="buttons">
            <button class="mobile-salir" @click="logout">
                <ion-icon name="log-out-outline"></ion-icon>
            </button>
            <template v-if="permissions?.includes('redaccion:data')">
                <RouterLink v-if="!modoRedaccion" :to="{ name: 'modo-redaccion' }">
                    <h3>MODO REDACCIÓN</h3>
                </RouterLink>
                <RouterLink v-else :to="{ name: 'main-view' }">
                    <h3>MODO NORMAL</h3>
                </RouterLink>
            </template>
            <button class="public-questions desktop-only" @click="goToPublicQuestions">Navegar preguntas
                públicas</button>
            <button v-if="!subscription && !ispago" class="suscribirse desktop-only" @click="goSuscribirse">
                <h3>✨ Suscribirse ✨</h3>
            </button>
            <div class="botones-contacto desktop-only">
                <a target="_blank"
                    href="https://docs.google.com/forms/d/18aMGrwHl0ZLLWMgXbXfmLqWfwyIU42wYc15WlVfU9KY/edit"><button
                        class="contactanos desktop-only">
                        <h3>Contactanos</h3>
                    </button></a>
                <button @click="showYate" class="yate desktop-only">
                    <h3>¿Ya te suscribiste? Activá la suscripción</h3>
                </button>
            </div>
            <button class="salir" @click="logout">
                <h3>Salir</h3>
            </button>
        </div>
        <!-- <h2>Debug mode:
            <label class="switch">
                <input type="checkbox" v-model="debug_mode">
                <span class="slider"></span>
            </label>
        </h2> -->
    </div>
</template>

<script>

export default {
    name: 'GeneralMetadataComponent',
    props: {
        email: {
            type: String,
            required: true
        },
        isSidebarMenuOpen: {
            type: Boolean,
            required: true
        },
        userName: {
            type: String,
            required: true
        },
        profilePicture: {
            type: String,
            required: false
        },
        subscription: {
            type: Object,
            required: false,
            default: null
        },
        ispago: {
            type: Boolean,
            required: false,
            default: false
        },
        hasSidebarMenu: {
            type: Boolean,
            required: false,
            default: false
        },
        modoRedaccion: {
            type: Boolean,
            required: false,
            default: false
        },
        permissions: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            debug_mode: false,
            botname: process.env.VUE_APP_BOT_PUBLIC_NAME
        };
    },

    methods: {
        logout() {
            this.$emit('logout');
        },
        toggleMenu() {
            this.$emit('toggle-menu');
        },
        goHome() {
            this.$router.push({ name: "main-view" });
        },
        goSuscribirse() {
            this.$router.push({ name: "suscribirse" });
        },
        showYate() {
            this.$router.push({ name: "yate" });
        },
        goToPublicQuestions() {
            this.$router.push({ name: "public-questions" });
        }
    },


};
</script>

<style scoped>
.logo {
    height: 75px
}

.metadata-container {
    width: 90%;
    padding: 20px;
    padding-top: 6px;
    padding-bottom: 6px;
    background-color: rgba(50, 50, 50, 0.9);
    border-radius: 0 0 8px 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    color: #333333;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

h1 {
    text-align: center;
    font-size: 24pt;
    color: #a1344e;
    letter-spacing: 10px;
    cursor: pointer;
}

h1 span {
    color: #f0f0f0;
    font-size: 15pt;
    letter-spacing: normal;
    vertical-align: middle;
    font-weight: 300;
}


.user-info {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-left: 24px;
    border-radius: 8px;
    overflow: hidden;
}


.user-info h2 {
    background-color: #ccc;
    padding: 12px;
    line-height: 1.5;
    font-size: 12pt;
    vertical-align: middle;
    display: flex;
    align-items: center;
    justify-content: center;
}



.user-info h3 {
    padding: 0 12px;
    color: #f0f0f0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-weight: 400;
    max-width: 400px;
}

.user-info h3 span {
    font-size: 10pt;
    vertical-align: baseline;
}

.user-info span.profile {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    overflow: hidden;
    display: inline-block;
    vertical-align: middle;
    margin-right: 12px;
    border: 2px solid #a1344e;
}

.user-info span.profile img {
    width: 100%;
    height: 100%;
}

button {
    border: none;
    border: 2px solid #a1344e;
    background-color: #ffffff;
    color: #ccc;
    border-radius: 8px;
    padding: 8px 24px;
    cursor: pointer;
    font-size: 12pt;
    margin-right: 24px;
}

.salir {
    color: #333333;
    border-color: #333333;
}

.mobile-salir {
    display: none;
}

.sidebar-menu {
    display: none;
}

.public-questions {
    color: #f0f0f0;
    text-decoration: underline;
    cursor: pointer;
    background-color: transparent;
    border: none;
}

ion-icon {
    font-size: 30pt;
    color: #a1344e;
    flex-shrink: 0;
}

.suscribirse {
    background-color: #a1344e;
    border: none;
    color: #f0f0f0;
}

.buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}

.botones-contacto {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.contactanos {
    background-color: transparent;
    border: none;
    font-size: 12pt;
    color: #f0f0f0;
    margin: 0;
    margin-bottom: 6px;
    padding: 0;
}

.yate {
    font-size: 12pt;
    background-color: #a1344e;
    padding: 0;
    color: #fff;
}

@media screen and (max-width: 768px) {
    .logo {
        height: 50px;
    }

    .desktop-only {
        display: none;
    }

    .metadata-container {
        width: 100%;
        justify-content: space-between;
        padding: 12px;
        margin-bottom: 0;
        z-index: 11;
        border-radius: 0;
        border-bottom: 1px solid #f0f0f0aa;
    }

    .metadata-container>h1 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        font-size: 13pt;
    }

    .metadata-container>h1 span {
        font-size: 11pt;
    }

    .salir,
    .user-info {
        display: none;
    }

    .sidebar-menu {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .mobile-salir {
        margin: 0;
        padding: 0;
        background-color: transparent;
        border: none;
        display: flex;
    }

    .mobile-salir ion-icon {
        font-size: 26pt;
    }

}
</style>